import { useMutation } from '@tanstack/react-query'

import { authServices } from '../authServices'
import { SendCodeToPhoneDTO, SendCodeToPhonePayload } from '../authTypes'

interface UseSendCodeToPhoneOptions {
  onSuccess?: (data: SendCodeToPhoneDTO) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useSendCodeToPhone = (options?: UseSendCodeToPhoneOptions) => {
  return useMutation<SendCodeToPhoneDTO, Error, SendCodeToPhonePayload>({
    mutationFn: authServices.sendCodeToPhone,
    onSuccess: (data) => {
      options?.onSuccess?.(data)
    },
    onError: (error) => {
      options?.onError?.({
        errorMessage: error.message || 'Something went wrong',
        code: 'UNKNOWN_ERROR',
      })
    },
  })
}
